var heading_default = {
  "fontElementMap": "q5yHG",
  "elementSpacing": "xb1AM",
  "headerOne": "yZe3G xb1AM",
  "headerTwo": "eeSJQ xb1AM",
  "headerThree": "L-UBF xb1AM",
  "headerFour": "Lig61 xb1AM",
  "headerFive": "fLFPg xb1AM",
  "headerSix": "-IFfu xb1AM",
  "child": "ym-gy"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
